// extracted by mini-css-extract-plugin
export default {"buttons":"LoadForm_buttons__FHgbL","tri-input":"LoadForm_tri-input__JOjzE","single-input":"LoadForm_single-input__6aX91"};